(function siteIndex($, Drupal) {
  Drupal.behaviors.siteIndex = {
    attach(context) {
      if (window.location.href.indexOf('site-index') > -1) {
        let ToC =
          '<div class="site-index__sidebar-toc">' +
            '<ul class="toc__list">';

        $('.site-index__section-title > h2', context).each(function () {
          const el = $(this);
          const title = el.text();
          /* eslint-disable prefer-template */
          const link = '#' + el.attr('id');

          const newLine =
            '<li class="toc__list-item">' +
            '<a class="toc__list-link" href="' + link + '">' +
            title +
            '</a>' +
            '</li>';

          ToC += newLine;
        });

        ToC +=
            '</ul>' +
          '</div>';

        // Insert the ToC after the title we've placed in the twig template.
        if ($('.site-index__sidebar-toc').length < 1) {
          $(ToC).insertAfter('.site-index__sidebar-title');
        }

        // Ensure scrolling is smooth.
        $('a[href*="#"]').on('click', function () {
          $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top,
          }, 500, 'linear');
        });
      }
    },
  };
}(jQuery, Drupal));
